<script>
import Layout from '@src/router/layouts/main'

export default {
  components: {
    Layout,
  },
  data() {
    return {
      showForm: false,
      categoria: 'Todas as Categorias',
      status: 'Todos os Status',
      periodo: 'Qualquer Período',
      form: {
        product: '',
        lotNumber: 'LOT-2024-X',
        supplier: '',
        invoice: '',
        fabricationDate: '',
        expirationDate: '',
        entryDate: '',
        initialQuantity: 0,
        currentQuantity: 0,
        status: 'Ativo',
        notes: '',
      },
      productOptions: [
        { value: '', text: 'Selecione um produto' },
        { value: 'Módulo Processador Pro-V2', text: 'Módulo Processador Pro-V2' },
        { value: 'Polipropileno G12', text: 'Polipropileno G12' },
        { value: 'Pigmento Orgânico Red 48', text: 'Pigmento Orgânico Red 48' },
      ],
      supplierOptions: [
        { value: '', text: 'Selecione o fornecedor' },
        { value: 'Química Norte Ltda', text: 'Química Norte Ltda' },
        { value: 'Insumos Brasil S/A', text: 'Insumos Brasil S/A' },
        { value: 'Distribuidora Central', text: 'Distribuidora Central' },
      ],
      categorias: [
        'Todas as Categorias',
        'Polímeros',
        'Pigmentos',
        'Resinas',
        'Solventes',
      ],
      statusOptions: ['Todos os Status', 'Ativo', 'Atenção', 'Vencido', 'Quarentena'],
      periodoOptions: [
        'Qualquer Período',
        'Próximos 30 dias',
        'Próximos 90 dias',
        'Vencidos',
      ],
      lots: [
        {
          code: 'LT-2024-001',
          product: 'Polipropileno G12',
          productId: 'ID: 4492-X',
          fabrication: '12/01/2024',
          expiration: '12/01/2026',
          quantity: '5.000 kg',
          status: 'Ativo',
        },
        {
          code: 'LT-2023-982',
          product: 'Pigmento Orgânico Red 48',
          productId: 'ID: 6921-B',
          fabrication: '15/06/2023',
          expiration: '22/05/2024',
          quantity: '250 kg',
          status: 'Atenção',
        },
        {
          code: 'LT-2022-114',
          product: 'Resina Epóxi Industrial',
          productId: 'ID: 3310-Z',
          fabrication: '01/01/2022',
          expiration: '01/01/2024',
          quantity: '1.200 kg',
          status: 'Vencido',
        },
        {
          code: 'LT-2024-045',
          product: 'Solvente Destilado V4',
          productId: 'ID: 7724-Y',
          fabrication: '05/04/2024',
          expiration: '05/04/2026',
          quantity: '3.400 L',
          status: 'Quarentena',
        },
      ],
    }
  },
  computed: {
    filteredLots() {
      return this.lots.filter((lot) => {
        const matchStatus = this.status === 'Todos os Status' || lot.status === this.status
        const matchCategory =
          this.categoria === 'Todas as Categorias' ||
          lot.product.toLowerCase().includes(this.categoria.toLowerCase().slice(0, 5))
        return matchStatus && matchCategory
      })
    },
    selectedProductLabel() {
      return this.form.product || 'Módulo Processador Pro-V2'
    },
  },
  methods: {
    openNewLot() {
      this.showForm = true
    },
    cancelNewLot() {
      this.showForm = false
    },
    clearFilters() {
      this.categoria = 'Todas as Categorias'
      this.status = 'Todos os Status'
      this.periodo = 'Qualquer Período'
    },
    statusClass(status) {
      return `is-${status.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`
    },
    isExpired(lot) {
      return lot.status === 'Vencido' || lot.status === 'Atenção'
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco lot-page">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-7 mb-2">
            <div class="titulo">
              <i class="uil uil-box"></i>
              {{ showForm ? 'Novo Cadastro de Lote' : 'Lotes' }}
            </div>
            <div class="subTitulo">
              {{ showForm ? 'Cadastre as informações, validade e quantidade inicial do lote.' : 'Acompanhe validade, status e volume dos lotes em estoque.' }}
            </div>
          </div>
          <div class="col-md-5">
            <div class="lot-page-actions">
              <button
                class="btn btn-light"
                type="button"
                @click="showForm ? cancelNewLot() : $router.push('/estoque/dashboard')"
              >
                <i class="uil uil-estate"></i>
                {{ showForm ? 'Histórico' : 'Dashboard' }}
              </button>
              <button class="btn btn-webreceita" type="button" @click="showForm ? null : openNewLot()">
                <i :class="showForm ? 'uil uil-save' : 'uil uil-plus-circle'"></i>
                {{ showForm ? 'Salvar Alterações' : 'Novo Lote' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div v-if="!showForm" class="lot-dashboard">
        <section class="lot-kpi-grid">
          <article class="lot-kpi-card">
            <div>
              <span>Total de Lotes</span>
              <strong>1,284</strong>
              <small class="is-positive"><i class="uil uil-chart-growth"></i> +12% este mês</small>
            </div>
            <i class="lot-kpi-icon is-positive uil uil-clipboard-notes"></i>
          </article>
          <article class="lot-kpi-card">
            <div>
              <span>Próximos ao Vencimento</span>
              <strong>24</strong>
              <small class="is-warning"><i class="uil uil-exclamation-triangle"></i> Próximos 30 dias</small>
            </div>
            <i class="lot-kpi-icon is-warning uil uil-stopwatch"></i>
          </article>
          <article class="lot-kpi-card">
            <div>
              <span>Lotes Vencidos</span>
              <strong class="is-danger">08</strong>
              <small class="is-danger"><i class="uil uil-exclamation-circle"></i> Ação imediata necessária</small>
            </div>
            <i class="lot-kpi-icon is-danger uil uil-calendar-slash"></i>
          </article>
          <article class="lot-kpi-card">
            <div>
              <span>Estoque Ativo</span>
              <strong>85,420</strong>
              <small>Volume total em unidades</small>
            </div>
            <i class="lot-kpi-icon is-neutral uil uil-cube"></i>
          </article>
        </section>

        <section class="lot-filter-card">
          <div>
            <label>Categoria do Produto</label>
            <b-form-select v-model="categoria" :options="categorias" />
          </div>
          <div>
            <label>Status</label>
            <b-form-select v-model="status" :options="statusOptions" />
          </div>
          <div>
            <label>Período de Vencimento</label>
            <b-form-select v-model="periodo" :options="periodoOptions" />
          </div>
          <button class="btn btn-light" type="button" @click="clearFilters">
            Limpar Filtros
          </button>
          <button class="btn btn-webreceita" type="button" @click="openNewLot">
            <i class="uil uil-plus-circle"></i>
            Novo Lote
          </button>
        </section>

        <section class="lot-table-card">
          <div class="lot-table-wrap">
            <table class="lot-table">
              <thead>
                <tr>
                  <th>Lote</th>
                  <th>Produto</th>
                  <th>Fabr.</th>
                  <th>Validade</th>
                  <th>Qtd</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="lot in filteredLots" :key="lot.code">
                  <td>
                    <strong class="lot-code">{{ lot.code }}</strong>
                  </td>
                  <td>
                    <strong>{{ lot.product }}</strong>
                    <small>{{ lot.productId }}</small>
                  </td>
                  <td>{{ lot.fabrication }}</td>
                  <td>
                    <strong :class="{ 'is-expired': isExpired(lot) }">
                      {{ lot.expiration }}
                    </strong>
                  </td>
                  <td>{{ lot.quantity }}</td>
                  <td>
                    <span :class="['lot-status', statusClass(lot.status)]">
                      {{ lot.status }}
                    </span>
                  </td>
                  <td>
                    <div class="lot-actions">
                      <button type="button"><i class="uil uil-history"></i></button>
                      <button type="button"><i class="uil uil-edit-alt"></i></button>
                    </div>
                  </td>
                </tr>
                <tr v-if="!filteredLots.length">
                  <td colspan="7" class="lot-empty">
                    Nenhum lote encontrado para os filtros selecionados.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <footer class="lot-table-footer">
            <span>Exibindo {{ filteredLots.length }} de 1,284 lotes</span>
            <div>
              <button type="button" disabled>Anterior</button>
              <button type="button" class="active">1</button>
              <button type="button">2</button>
              <button type="button">3</button>
              <span>...</span>
              <button type="button">Próximo</button>
            </div>
          </footer>
        </section>
      </div>

      <div v-else class="lot-dashboard">
        <div class="lot-form-grid">
          <main class="lot-form-main">
            <section class="lot-form-card">
              <h2><i class="uil uil-info-circle"></i> Informações do Lote</h2>
              <div class="lot-form-fields two-columns">
                <b-form-group label="Produto">
                  <b-form-select v-model="form.product" :options="productOptions" />
                </b-form-group>
                <b-form-group label="Número do Lote">
                  <b-form-input v-model="form.lotNumber" placeholder="Ex: LOT-2024-001" />
                </b-form-group>
                <b-form-group label="Fornecedor">
                  <b-form-select v-model="form.supplier" :options="supplierOptions" />
                </b-form-group>
                <b-form-group label="Nota Fiscal de Entrada">
                  <b-form-input v-model="form.invoice" placeholder="000.000.000" />
                </b-form-group>
              </div>
            </section>

            <section class="lot-form-card">
              <h2><i class="uil uil-calendar-alt"></i> Datas e Quantidades</h2>
              <div class="lot-form-fields three-columns">
                <b-form-group label="Data de Fabricação">
                  <b-form-input v-model="form.fabricationDate" type="date" />
                </b-form-group>
                <b-form-group label="Data de Validade">
                  <b-form-input v-model="form.expirationDate" type="date" />
                </b-form-group>
                <b-form-group label="Data de Entrada">
                  <b-form-input v-model="form.entryDate" type="date" />
                </b-form-group>
              </div>
              <div class="lot-form-fields two-columns has-separator">
                <b-form-group label="Quantidade Inicial">
                  <b-input-group append="unid.">
                    <b-form-input v-model="form.initialQuantity" type="number" />
                  </b-input-group>
                </b-form-group>
                <b-form-group label="Quantidade Atual">
                  <b-input-group append="unid.">
                    <b-form-input v-model="form.currentQuantity" type="number" />
                  </b-input-group>
                  <small>Calculado automaticamente</small>
                </b-form-group>
              </div>
            </section>

            <section class="lot-form-card">
              <h2><i class="uil uil-clipboard-notes"></i> Status e Observações</h2>
              <b-form-group label="Situação do Lote" class="lot-radio-group">
                <b-form-radio-group v-model="form.status">
                  <b-form-radio value="Ativo">Ativo</b-form-radio>
                  <b-form-radio value="Inativo">Inativo</b-form-radio>
                  <b-form-radio value="Em Quarentena">Em Quarentena</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group label="Observações">
                <b-form-textarea
                  v-model="form.notes"
                  rows="5"
                  placeholder="Insira detalhes adicionais sobre o lote, condições de armazenamento ou restrições..."
                />
              </b-form-group>
            </section>
          </main>

          <aside class="lot-form-sidebar">
            <section class="lot-summary-card">
              <div class="lot-summary-head">
                <span>Resumo do Lote</span>
                <b>Rascunho</b>
              </div>
              <div class="lot-summary-product">
                <i class="uil uil-processor"></i>
                <div>
                  <small>Produto selecionado</small>
                  <strong>{{ selectedProductLabel }}</strong>
                </div>
              </div>
              <div class="lot-summary-meta">
                <div>
                  <span>Número</span>
                  <strong>{{ form.lotNumber || 'LOT-2024-X' }}</strong>
                </div>
                <div>
                  <span>Validade</span>
                  <strong>{{ form.expirationDate || '--/--/----' }}</strong>
                </div>
              </div>
              <button class="btn btn-outline-success" type="button">
                Salvar e Criar Novo
              </button>
              <button class="btn btn-link" type="button" @click="cancelNewLot">
                <i class="uil uil-times"></i>
                Cancelar Operação
              </button>
            </section>

            <section class="lot-tip-card">
              <i class="uil uil-lightbulb-alt"></i>
              <div>
                <strong>Dica de Produtividade</strong>
                <p>
                  Lotes com validade próxima de 30 dias serão marcados automaticamente com o status "Atenção".
                </p>
              </div>
            </section>

            <section class="lot-flow-card">
              <h3><i class="uil uil-clipboard-alt"></i> Fluxo de Aprovação</h3>
              <ol>
                <li class="is-active">Criação do Registro (Agora)</li>
                <li>Validação Fiscal</li>
                <li>Conferência Física</li>
              </ol>
            </section>
          </aside>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
.bloco.lot-page {
  background: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
  margin-top: 24px;
  padding: 32px;
  position: relative;
}

.lot-page .titulo {
  align-items: center;
  color: #008e75;
  display: flex;
  font-size: 25px;
  font-weight: 800;
  gap: 8px;
  line-height: 1.2;
  margin-bottom: 8px;
}

.lot-page .subTitulo {
  color: #536074;
  font-size: 14px;
}

.lot-page .borda {
  border-bottom: 1px solid #edeff4;
  margin: 15px 0 18px;
}

.lot-page-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.lot-page-actions .btn,
.lot-filter-card .btn {
  align-items: center;
  border-radius: 5px;
  display: inline-flex;
  font-weight: 700;
  gap: 7px;
  height: 42px;
  justify-content: center;
  margin: 0;
  min-width: 130px;
  padding: 0 18px;
}

.btn-light {
  background: #fff;
  border: 1px solid #d8dee8;
  color: #172033;
}

.btn-webreceita {
  background: #008e75;
  border-color: #008e75;
  color: #fff;
}

.lot-dashboard {
  background: #f5f7fb;
  display: grid;
  gap: 18px;
  margin: 0 -32px -32px;
  padding: 18px 32px 32px;
}

.lot-kpi-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.lot-kpi-card,
.lot-filter-card,
.lot-table-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
}

.lot-kpi-card {
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 118px;
  padding: 18px 20px;
}

.lot-kpi-card span {
  color: #536074;
  display: block;
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 8px;
}

.lot-kpi-card strong {
  color: #172033;
  display: block;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 10px;
}

.lot-kpi-card strong.is-danger {
  color: #dc3545;
}

.lot-kpi-card small {
  color: #536074;
  display: block;
  font-size: 11px;
  font-weight: 800;
}

.lot-kpi-card small.is-positive { color: #008e75; }
.lot-kpi-card small.is-warning { color: #b86e12; }
.lot-kpi-card small.is-danger { color: #dc3545; }

.lot-kpi-icon {
  align-items: center;
  border-radius: 8px;
  display: inline-flex;
  flex: 0 0 46px;
  font-size: 22px;
  height: 46px;
  justify-content: center;
  width: 46px;
}

.lot-kpi-icon.is-positive { background: #e3f7f1; color: #008e75; }
.lot-kpi-icon.is-warning { background: #fff0f1; color: #b45d59; }
.lot-kpi-icon.is-danger { background: #ffe9ed; color: #dc3545; }
.lot-kpi-icon.is-neutral { background: #eef1f2; color: #536074; }

.lot-filter-card {
  align-items: end;
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto auto;
  padding: 22px;
}

.lot-filter-card label {
  color: #536074;
  display: block;
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 8px;
}

.lot-filter-card .custom-select {
  border-color: #d8dee8;
  color: #536074;
  font-weight: 700;
  height: 42px;
}

.lot-table-card {
  overflow: hidden;
}

.lot-table-wrap {
  overflow-x: auto;
}

.lot-table {
  border-collapse: collapse;
  min-width: 900px;
  width: 100%;
}

.lot-table th {
  background: #eef3fb;
  color: #536074;
  font-size: 12px;
  font-weight: 800;
  padding: 16px 20px;
  text-align: left;
  text-transform: uppercase;
}

.lot-table td {
  border-top: 1px solid #e7edf4;
  color: #536074;
  font-size: 14px;
  font-weight: 700;
  padding: 18px 20px;
  vertical-align: middle;
}

.lot-table td > strong {
  color: #172033;
  display: block;
  font-size: 14px;
  font-weight: 800;
}

.lot-table td small {
  color: #7b8796;
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin-top: 3px;
}

.lot-code {
  color: #008e75 !important;
}

.is-expired {
  color: #dc3545 !important;
}

.lot-status {
  border-radius: 999px;
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  padding: 5px 12px;
  text-transform: uppercase;
}

.lot-status.is-ativo {
  background: #e4f6f0;
  color: #008e75;
}

.lot-status.is-atencao {
  background: #fff0f2;
  color: #b45d59;
}

.lot-status.is-vencido {
  background: #ffe9ed;
  color: #dc3545;
}

.lot-status.is-quarentena {
  background: #e6f0ef;
  color: #536074;
}

.lot-actions {
  display: flex;
  gap: 14px;
}

.lot-actions button {
  background: transparent;
  border: 0;
  color: #008e75;
  font-size: 18px;
  padding: 0;
}

.lot-empty {
  color: #647084;
  text-align: center;
}

.lot-table-footer {
  align-items: center;
  background: #fff;
  border-top: 1px solid #dfe6ef;
  color: #647084;
  display: flex;
  justify-content: space-between;
  padding: 16px 20px;
}

.lot-table-footer div {
  align-items: center;
  display: flex;
  gap: 8px;
}

.lot-table-footer button {
  background: #fff;
  border: 1px solid #d8dee8;
  border-radius: 5px;
  color: #536074;
  font-weight: 700;
  height: 34px;
  min-width: 34px;
  padding: 0 12px;
}

.lot-table-footer button.active {
  background: #008e75;
  border-color: #008e75;
  color: #fff;
}

.lot-table-footer button:disabled {
  color: #b3bbc8;
}

.lot-form-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(0, 1fr) 320px;
}

.lot-form-main,
.lot-form-sidebar {
  display: grid;
  gap: 18px;
}

.lot-form-card,
.lot-summary-card,
.lot-tip-card,
.lot-flow-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
}

.lot-form-card {
  padding: 26px;
}

.lot-form-card h2 {
  align-items: center;
  color: #172033;
  display: flex;
  font-size: 18px;
  font-weight: 800;
  gap: 10px;
  margin: 0 0 24px;
}

.lot-form-card h2 i {
  align-items: center;
  background: #dff3ec;
  border-radius: 5px;
  color: #008e75;
  display: inline-flex;
  font-size: 17px;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.lot-form-fields {
  display: grid;
  gap: 18px 24px;
}

.lot-form-fields.two-columns {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.lot-form-fields.three-columns {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.lot-form-fields.has-separator {
  border-top: 1px solid #edeff4;
  margin-top: 20px;
  padding-top: 24px;
}

.lot-form-card ::v-deep label {
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.lot-form-card ::v-deep .form-control,
.lot-form-card ::v-deep .custom-select {
  border-color: #cfd8d3;
  border-radius: 5px;
  color: #172033;
  font-weight: 600;
  height: 44px;
}

.lot-form-card ::v-deep textarea.form-control {
  height: auto;
}

.lot-form-card ::v-deep .input-group-text {
  background: #fff;
  border-color: #cfd8d3;
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.lot-form-card small {
  color: #536074;
  display: block;
  font-size: 11px;
  font-style: italic;
  margin-top: 8px;
}

.lot-radio-group ::v-deep .custom-control {
  margin-right: 18px;
}

.lot-radio-group ::v-deep .custom-control-label {
  font-size: 13px;
  font-weight: 700;
}

.lot-summary-card {
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.lot-summary-head {
  align-items: center;
  background: #f8fbfd;
  border-bottom: 1px solid #dfe6ef;
  display: flex;
  justify-content: space-between;
  padding: 20px 22px;
}

.lot-summary-head span {
  color: #172033;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.lot-summary-head b {
  background: #dff3ec;
  border-radius: 999px;
  color: #008e75;
  font-size: 10px;
  padding: 4px 9px;
  text-transform: uppercase;
}

.lot-summary-product {
  align-items: center;
  display: flex;
  gap: 12px;
  margin: 0 22px;
  padding: 24px 0 18px;
}

.lot-summary-product i {
  align-items: center;
  background: #eef3fb;
  border-radius: 5px;
  color: #536074;
  display: inline-flex;
  font-size: 22px;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.lot-summary-product small,
.lot-summary-meta span {
  color: #536074;
  display: block;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
}

.lot-summary-product strong {
  color: #008e75;
  display: block;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
}

.lot-summary-meta {
  border-top: 1px solid #edeff4;
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0 22px;
  padding: 18px 0 24px;
}

.lot-summary-meta strong {
  color: #172033;
  display: block;
  font-size: 13px;
  font-weight: 800;
  margin-top: 5px;
}

.lot-summary-card .btn {
  align-items: center;
  display: flex;
  font-weight: 800;
  justify-content: center;
  margin: 0 22px 14px;
  min-height: 42px;
  width: calc(100% - 44px);
}

.lot-summary-card .btn-outline-success {
  border-color: #008e75;
  color: #008e75;
}

.lot-summary-card .btn-link {
  color: #172033;
  text-decoration: none;
}

.lot-tip-card {
  align-items: flex-start;
  background: #e9f6f4;
  border-color: #bee2dc;
  display: flex;
  gap: 12px;
  padding: 22px;
}

.lot-tip-card > i {
  color: #008e75;
  font-size: 22px;
}

.lot-tip-card strong {
  color: #008e75;
  display: block;
  font-size: 13px;
  margin-bottom: 6px;
}

.lot-tip-card p {
  color: #536074;
  font-size: 12px;
  margin: 0;
}

.lot-flow-card {
  border-style: dashed;
  padding: 20px 22px;
}

.lot-flow-card h3 {
  align-items: center;
  color: #536074;
  display: flex;
  font-size: 13px;
  font-weight: 800;
  gap: 8px;
  margin: 0 0 14px;
}

.lot-flow-card h3 i {
  color: #172033;
}

.lot-flow-card ol {
  border-left: 1px solid #dfe6ef;
  list-style: none;
  margin: 0 0 0 6px;
  padding: 0 0 0 18px;
}

.lot-flow-card li {
  color: #b3bbc8;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 14px;
  position: relative;
}

.lot-flow-card li::before {
  background: #cfd8d3;
  border-radius: 50%;
  content: "";
  height: 8px;
  left: -23px;
  position: absolute;
  top: 4px;
  width: 8px;
}

.lot-flow-card li.is-active {
  color: #172033;
}

.lot-flow-card li.is-active::before {
  background: #008e75;
}

@media (max-width: 1199px) {
  .lot-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lot-filter-card,
  .lot-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lot-form-sidebar {
    grid-column: 1 / -1;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .lot-page-actions,
  .lot-table-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .lot-page-actions .btn,
  .lot-filter-card .btn,
  .lot-filter-card .custom-select {
    width: 100%;
  }

  .lot-kpi-grid,
  .lot-filter-card,
  .lot-form-grid,
  .lot-form-sidebar,
  .lot-form-fields.two-columns,
  .lot-form-fields.three-columns {
    grid-template-columns: 1fr;
  }
}
</style>
